import React, { useContext } from 'react';
import { Box, Typography, Button } from '@mui/material';
import Sidebar from '../../components/Sidebar/Sidebar';
import './Home.scss';
import { UserContext } from '../../contexts/UserContext';
import moment from 'moment';

const formatDate = (date) => {
  return date ? moment(date).format('DD-MM-YYYY HH:mm') : '';
  };

const Home = () => {
  const { user } = useContext(UserContext);
  return (
    <Box className="StyledContainer">
      <Sidebar /> 
      <Box className="StyledContent">
        <Typography variant="h2">Self-Service Content</Typography>
        <Box className="StyledButtonContainer">
          <Box className="StyledCard">
            <Typography variant="h5" className="StyledCardTitle">Tutorials</Typography>
            <Typography variant="body1" className="StyledCardText">Check out our tutorials for a smooth experience</Typography>
            <Button className="CustomButton" variant="contained" color="primary" href="https://mee6.xyz/tutorials" target="_blank" rel="noopener noreferrer">
              Go to Tutorials
            </Button>
          </Box>
          <Box className="StyledCard">
            <Typography variant="h5" className="StyledCardTitle">Helpdesk</Typography>
            <Typography variant="body1" className="StyledCardText">Visit our helpdesk for any assistance</Typography>
            <Button className="CustomButton" variant="contained" color="primary" href="https://help.mee6.xyz" target="_blank" rel="noopener noreferrer">
              Visit Helpdesk
            </Button>
          </Box>
          <Box className="StyledCard">
            <Typography variant="h5" className="StyledCardTitle">Discord Support Server</Typography>
            <Typography variant="body1" className="StyledCardText">Join our Discord support server for live support</Typography>
            <Button className="CustomButton" variant="contained" color="primary" href="https://discord.gg/mee6" target="_blank" rel="noopener noreferrer">
              Join Discord Server
            </Button>
          </Box>
          <Box className="StyledCard">
            <Typography variant="h5" className="StyledCardTitle">
              {user ? 'Logout' : 'Login'}
            </Typography>
            <Typography variant="body1" className="StyledCardText">
              {user ? 'Log out from the platform' : 'Log in to the platform'}
            </Typography>
            <Button
              className="CustomButton"
              variant="contained"
              color="primary"
              href={user ? "/logout" : "/login"}  // Update the href accordingly
              rel="noopener noreferrer"
            >
              {user ? 'Logout' : 'Login'}
            </Button>
          </Box>
        </Box>
      </Box>
      {user ? <Typography>Last login: {formatDate(user.last_auth)}</Typography> : null}
    </Box>

  );
};

export default Home;
